import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import classNames from 'classnames';
import { useMemo } from 'react';

import css from './map.css';

interface MapProps {
  className?: string;
  center?: {
    latitude: number;
    longitude: number;
  };
  zoom?: number;
}

export function Map(props: MapProps) {
  const { zoom, className } = props;
  const center = useMemo(
    () =>
      props.center
        ? {
          lat: props.center.latitude,
          lng: props.center.longitude
        }
        : undefined,
    [props.center]
  );
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName={classNames(css.mapContainer, className)}
      center={center}
      zoom={zoom}
    ></GoogleMap>
  ) : null;
}
